import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MbNavigationService, NavigationNode } from '../../mb-navigation.service'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { SelectedSubCategories } from '../mb-category-navigation.module'
import { NavigationSubCategoryClickEvent } from '../../../components/types'
import { WindowRef } from '@spartacus/core'
import { MbConstants } from '../../../../shared/mb-constants'
import { map } from 'rxjs/operators'

@Component({
  selector: 'mb-category-navigation-second-level',
  templateUrl: './mb-category-navigation-second-level.component.html',
  styleUrls: ['./mb-category-navigation-second-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationSecondLevelComponent {

  @Output() closeEvent = new EventEmitter<Event>()
  @Output() subCategoryClick = new EventEmitter<NavigationSubCategoryClickEvent>()

  @Input() set dataFiltered (dataFiltered: boolean | null) {
    this.dataFiltered$.next(!!dataFiltered)
  }

  @Input() set selectedCategory (selectedCategory: NavigationNode | undefined | null) {
    this.selectedCategory$.next(selectedCategory)
  }

  @Input() set activeFilter (activeFilter: NavigationNode | undefined | null) {
    this.activeFilter$.next(activeFilter)
  }

  @Input() set selectedSubCategories (selectedSubCategories: SelectedSubCategories | undefined | null) {
    this.selectedSubCategories$.next(selectedSubCategories)
  }

  @Input() set activeSubCategory (activeSubCategory: NavigationNode | undefined | null) {
    this.activeSubCategory$.next(activeSubCategory)
  }

  @Input() set isSubCategorySelected (isSubCategorySelected: boolean | null) {
    this.isSubCategorySelected$.next(!!isSubCategorySelected)
  }

  dataFiltered$ = new BehaviorSubject(false)
  selectedCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  activeFilter$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  selectedSubCategories$ = new BehaviorSubject<SelectedSubCategories | undefined | null>(undefined)
  activeSubCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  isSubCategorySelected$ = new BehaviorSubject(false)

  state$ = combineLatest([
    this.navigationService.navigation$,
    this.dataFiltered$,
    this.selectedCategory$,
    this.activeFilter$,
    this.selectedSubCategories$,
    this.activeSubCategory$,
    this.isSubCategorySelected$
  ]).pipe(
    map(([navigation, dataFiltered, selectedCategory, activeFilter, selectedSubCategories, activeSubCategory, isSubCategorySelected]) => ({
      navigation,
      dataFiltered,
      selectedCategory,
      activeFilter,
      selectedSubCategories,
      activeSubCategory,
      isSubCategorySelected
    }))) as BehaviorSubject<CategoryNavigationSecondLevelState>

  navigation$ = this.navigationService.navigation$

  constructor (private navigationService: MbNavigationService,
               private winRef: WindowRef) {
  }

  emitSubCategoryClickEvent ($event: MouseEvent, category: NavigationNode, subCategory: NavigationNode, filter?: NavigationNode) {
    this.subCategoryClick.emit({
      event: $event,
      category,
      subCategory: subCategory?.children?.length ? subCategory : undefined,
      additionalIdentifier: filter || undefined
    })
  }

  isCurrentRoute (route: string = ''): boolean {
    if (this.winRef.isBrowser() && this.winRef.nativeWindow) {
      const path = this.winRef.nativeWindow.location.pathname
      return path?.endsWith(route)
    }
    return false
  }

  readonly orange = MbConstants.CORPORATE_ORANGE
  readonly applications = MbConstants.APPLICATIONS
  readonly products = MbConstants.PRODUCTS
}

interface CategoryNavigationSecondLevelState {
  navigation: NavigationNode[];
  dataFiltered: boolean;
  selectedCategory: NavigationNode | undefined | null;
  activeFilter: NavigationNode | undefined | null;
  selectedSubCategories: SelectedSubCategories | undefined | null;
  activeSubCategory: NavigationNode | undefined | null;
  isSubCategorySelected: boolean;
}
